import { render } from "./completedAppointments.vue?vue&type=template&id=d56f4ea8"
import script from "./completedAppointments.vue?vue&type=script&lang=js"
export * from "./completedAppointments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__